export function On() {
  'ngInject';

  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      const events = scope.$eval(attr.updOn);
      Object.keys(events).forEach((event) => {
        const fn = events[event];
        element.on(event, (e) => {
          scope.$apply(() => {
            fn(scope, { $event: e });
          });
        });
      });
    },
  };
}
